(ns hai.web-app.add-menu
  "Task add modal + shared note-create event.

  Mobile drives an add bottom-sheet (hai.home.mobile.add-sheet) whose task
  tile opens the modal defined here; note creation goes through the expanded
  editor (hai.notes.create) on every surface. The desktop universal
  \"Add anything…\" bar dispatches the shared `::add-note` event below when
  note text is typed straight into it."
  (:require
   [hai.notes.data :as notes-data]
   [hai.tasks.data :as tasks-data]
   [hai.tasks.ui :as tasks-ui]
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s >e defevent defevent-fx defsub]]))

;; ---------------------------------------------------------------------------
;; Note events
;; ---------------------------------------------------------------------------

(defevent-fx ::add-note [_ {:keys [text tag-uuids tag-names link-urls]}]
  {:resolve {:query [{(list 'note/upsert
                            (cond-> {:note/text text
                                     :note/source :web-app}
                              (seq tag-uuids) (assoc :note/tag-uuids tag-uuids)
                              (seq tag-names) (assoc :note/tag-names tag-names)
                              (seq link-urls) (assoc :activity/urls link-urls)))
                      [:note/uuid]}]
             :store-in [::add-note-result]
             :on-success-fx [[:dispatch [::add-note-done]]]}})

;; A note can now be added from anywhere, so refresh whichever list the
;; user is actually looking at — and nothing otherwise.
(defevent-fx ::add-note-done [{:keys [db]} _]
  (let [route (get-in db [:routing/current-route :data :name])]
    {:fx (into [[:dispatch [:toast/success {:text "Note saved"}]]]
               (case route
                 :timelines/view [[:dispatch [:timeline/load-entries]]]
                 :notes/view     [[:dispatch [:table/resolve notes-data/table-id]]]
                 []))}))

;; ---------------------------------------------------------------------------
;; Task events
;;
;; Task creation reuses hai.tasks.data/create, which persists via the
;; task/create resolver and prepends to :hai.tasks.data/list — the same
;; key the Desktop card subscribes to and reloads on every visit. So a task
;; added from here shows up wherever tasks are shown, no extra refresh.
;; ---------------------------------------------------------------------------

(defsub ::task-modal-open? [db]
  (get db ::task-modal-open? false))

(defevent ::open-task-modal [db _]
  (assoc db ::task-modal-open? true))

(defevent ::close-task-modal [db _]
  (dissoc db ::task-modal-open?))

;; ---------------------------------------------------------------------------
;; Task modal
;; ---------------------------------------------------------------------------

;; Radix Dialog.Content wants a description for a11y; the form speaks for
;; itself, so hide it.
(def ^:private visually-hidden
  {:position "absolute" :width "1px" :height "1px" :padding "0" :margin "-1px"
   :overflow "hidden" :clip "rect(0 0 0 0)" :white-space "nowrap" :border "0"})

(defn task-modal []
  (let [open? @(<s [::task-modal-open?])]
    [c/DialogRoot
     {:open open?
      :onOpenChange (fn [opening?]
                      (when-not opening?
                        (>e [::close-task-modal])))}
     [c/DialogContent {:max-width "480px"}
      [c/DialogTitle {:style {:color "var(--card-forest)"}} "Add a task"]
      [c/dialog-close-x]
      [c/DialogDescription {:style visually-hidden} "Create a new task."]
      (when open?
        [tasks-ui/quick-add {:class "flush"}
         [tasks-ui/task-form
          {:form-id       ::task-form
           :placeholder   "Give your task a title…"
           :primary-label "add"
           :auto-focus?   true
           :assignable?   true
           :initial-assignee @(<s :auth/identity)
           :on-save       (fn [task]
                            (>e [::tasks-data/create task])
                            (>e [:form/reset ::task-form])
                            (>e [::close-task-modal]))
           :on-cancel     (fn []
                            (>e [:form/reset ::task-form])
                            (>e [::close-task-modal]))}]])]]))

(defn modals []
  [:<>
   [task-modal]])
